<div class="">
  <div class="row">
    <div class="middle-container xs-mt-0">
      <div class="status-bar">
        <strong class="xs-mr-20">Status Notice:</strong> Your order has been submitted. You will receive an e-mail
        confirmation.
      </div>
      <div class="row xs-p-15 columns">
        <div class="col-md-3">
          <div class="row">
            <div class="col-sm-4">QUOTE #:</div>
            <div class="col-sm-8">
              <strong>{{data.quoteNumber}}</strong>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="row">
            <div class="col-sm-4">ACCOUNT:</div>
            <div class="col-sm-8">
              <strong>
                <span *ngIf="data.accountName">{{data.accountName}}<br></span>
                <span *ngIf="data.address">{{data.address}}<br></span>
                <span *ngIf="data.city">{{data.city}} , {{data.state}}<br></span>
                <span *ngIf="data.zipCode">{{data.zipCode}}</span>
              </strong>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="row">
            <div class="col-sm-4">QUOTE DATE:</div>
            <div class="col-sm-8">
              <strong>{{data.quoteDate | date:'MM/dd/yyyy'}}</strong>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-4">CLOSE DATE:</div>
            <div class="col-sm-8">
              <strong>{{data.closeDate | date:'MM/dd/yyyy'}}</strong>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-2">
          <div class="d-flex justify-content-between align-items-center">
            <div class="d-flex align-items-center pdfText">
              <span class="round-icon xs-mr-15" (click)="generatePdf()">
                <i class="far fa-file-pdf"></i>
              </span>
              View PDF to Print
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="scrollable">
    <div *ngFor="let item of itemsDataSource; let i = index">
      <div class="row bgColor">
        <div class="middle-container xs-pt-15 xs-pb-15">
          <div class="row xs-p-15 columns">
            <div class="col-md-3">
              <div class="row">
                <div class="col-sm-4">ORDER #:</div>
                <div class="col-sm-8">
                  <strong>{{item.webOrderNumber}}</strong>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-4">CREATED:</div>
                <div class="col-sm-8">
                  <strong>{{item.createdOn | date:'MM/dd/yyyy'}}</strong>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-4">PLACED BY #:</div>
                <div class="col-sm-8">
                  <strong>{{item.placedByName}}</strong>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-4">CUSTOMER PO:</div>
                <div class="col-sm-8">
                  <strong>{{item.custPONumber}}</strong>
                </div>
              </div>
            </div>
            <div class="col-md-3" *ngIf="item.soldToDetail.accountName">
              <div class="row">
                <div class="col-sm-4">SOLD TO:</div>
                <div class="col-sm-8">
                  <strong>
                    <span *ngIf="item.soldToDetail.accountNo">{{item.soldToDetail.accountNo}}</span><br>
                    <span *ngIf="item.soldToDetail.accountName">{{item.soldToDetail.accountName}}<br></span>
                    <span *ngIf="item.soldToDetail.address1">{{item.soldToDetail.address1}}<br></span>
                    <span *ngIf="item.soldToDetail.address2">{{item.soldToDetail.address2}}<br></span>
                    <span *ngIf="item.soldToDetail.city">
                      {{item.soldToDetail.city}} , {{item.soldToDetail.state}}
                    </span><br>
                    <span *ngIf="item.soldToDetail.zipCode">{{item.soldToDetail.zipCode}}</span>
                  </strong>
                </div>
              </div>
            </div>
            <div class="col-md-3">
              <div class="row">
                <div class="col-sm-4">SHIP TO:</div>
                <div class="col-sm-8">
                  <strong>
                    {{item.accountNumber}}<br>
                    {{item.accountName}}<br>
                    {{item.accountAddress1}}<br>

                    {{item.accountCity}} , {{item.accountState}}<br>
                    {{item.accountZipCode}}
                  </strong>
                </div>
              </div>
            </div>
            <div class="col-md-3" *ngIf="item.deliverToDetail && item.deliverToDetail.accountName">
              <div class="row">
                <div class="col-sm-4">DELIVER TO:</div>
                <div class="col-sm-8">
                  <strong>
                    <span *ngIf="item.soldToDetail.accountNo">{{item.deliverToDetail.accountNo}}</span><br>
                    <span *ngIf="item.soldToDetail.accountName">{{item.deliverToDetail.accountName}}<br></span>
                    <span *ngIf="item.soldToDetail.address1">{{item.deliverToDetail.address1}}<br></span>
                    <span *ngIf="item.soldToDetail.city">
                      {{item.deliverToDetail.city}} , {{item.deliverToDetail.state}}<br />
                    </span>
                    <span *ngIf="item.soldToDetail.zipCode">{{item.deliverToDetail.zipCode}}</span>
                  </strong>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="row" *ngIf="item.dsmDetail != null && item.dsmDetail.dsmAccountName">
                <div class="col-sm-4">DSM:</div>
                <div class="col-sm-8">
                  <strong>
                    {{item.dsmDetail.dsmAccountName}}<br>
                    <span class="xs-mt-10" *ngIf="item.dsmDetail.emailAddress">{{item.dsmDetail.emailAddress}}</span>
                  </strong>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-12">
            <span class="link">
              <a data-toggle="collapse" data-toggle="collapse" (click)="item.isCollapsed = !item.isCollapsed">
                <ng-container *ngIf="item.isCollapsed">Hide</ng-container>
                <ng-container *ngIf="!item.isCollapsed">View</ng-container> Order Details
              </a>
            </span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="middle-container xs-pt-0 xs-pb-15">
          <div [@smoothCollapse]="!item.isCollapsed ?'initial':'final'">
            <ng-container *ngIf="itemsDataSource && itemsDataSource.length">
              <div *ngFor="let detail of item.splitDetails">
                <!-- <div class="row" *ngIf="item.hasError">
                  <div class="col-md-12">
                    <button class=" textAlignment errorSummary">{{getErrorMessagesForProduct()}}</button>
                  </div>
                </div> -->
                <div class="row  margin-t20 margin-b10 stat-row">
                  <div class="col-md-3">
                    <span><b>Order ID: {{item.webOrderNumber}}-{{detail.splitId}}</b></span>
                  </div>
                  <div class="col-md-3">
                    <span *ngIf="detail.jdeorderNumber && data.quoteClose"><b>Sales Order Number: {{detail.jdeorderNumber}}</b></span>
                  </div>
                  <div class="col-md-3">
                    <span *ngIf="data.quoteClose">
                      <b>
                        Status:
                        <button [ngClass]="detail.orderStatus =='ERROR' ? 'statusFailed' : 'statusSuccess'">{{detail.orderStatus}}</button>
                      </b>
                    </span>
                  </div>
                  <div class="col-md-3">
                    <span class="float-right" *ngIf="getDeliveryDate(detail)">
                      <b>
                        Requested Arrival Date:
                        {{getDeliveryDate(detail) | date:'MM/dd/yyyy'}}
                      </b>
                    </span>
                  </div>
                </div>

                <div class="tableContainer cppsummaryTable botMargin">
                  <app-quote-order-summary-grid [gridData]="detail"></app-quote-order-summary-grid>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="footer-action">
  <div class="row">
    <div class="col-md-11 ml-auto mr-auto d-flex">
      <button mat-raised-button class="btns" (click)="backToLandingPage()">Back To Order List</button>
    </div>
  </div>
</div>
